<template>
  <section>
    <Header></Header>
    <div class="body">
      <div class="tech screen">
        <SectionSolutionWelcome/>
        <SectionSolutionCapbl/>
        <SectionSolutionDAB/>
        <SectionSolutionJsondoc/>
      </div>    
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import SectionSolutionWelcome from "../components/SectionSolutionWelcome.vue";
import SectionSolutionCapbl from "../components/SectionSolutionCapbl.vue"
import SectionSolutionDAB from "../components/SectionSolutionDAB.vue"
import SectionSolutionJsondoc from "../components/SectionSolutionJsondoc.vue"
import SectionGrayReference from "../components/SectionGrayReference.vue"
import SectionTechFrontChat from "../components/SectionTechFrontChat.vue"
import SectionTechFrontChatBottom from "../components/SectionTechFrontChatBottom.vue"
import SectionTechBackend from "../components/SectionTechBackend.vue"
import SectionTechDataPlay from "../components/SectionTechDataPlay.vue"
import SectionTechDistribution from "../components/SectionTechDistribution.vue"

import loginService from "../services/loginService";
import client from "../client/client";

export default {
  name: "Main",
  components: {
    Header,
    Footer,
    SectionSolutionWelcome,
    SectionSolutionCapbl,
    SectionGrayReference,
    SectionSolutionDAB,
    SectionSolutionJsondoc,
  },
  data: function () {
    return {
      success: false,
      loginErrorMsg: "",
      username: "",
      password: "",
    };
  },
  mounted() {},
  methods: {
    async login() {
      if (!this.username || !this.password) return;

      const result = await loginService.login(this.username, this.password);
      if (result.r) {
        this.success = true;
        this.loginErrorMsg = "";
      } else {
        this.success = false;
        this.loginErrorMsg = result.msg;
      }
    },
  },
};
</script>

<style scoped>
</style>
